var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"backoffice"},[_c('section',{staticClass:"backoffice__container",attrs:{"id":"backoffice__container"}},[_vm._t("container")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }